import { useChargebeePortal } from '../util/chargebee';
import useSubscription from './useSubscription';
import { BillingProvider } from '../util/constants';
import useOrganisation from './useOrganisation';

// uses _id from the subscription object
function Chargebee({ subscriptionId, shortCode }) {
  const { clickCallback: chargebeeClickCallback } = useChargebeePortal({
    openSubscription: subscriptionId,
    shortCode,
  });

  return chargebeeClickCallback;
}

function useManageSubscription() {
  const {
    subscription: { _id, subscriptionService },
  } = useSubscription();
  const { ShortCode } = useOrganisation();

  switch (subscriptionService) {
    case BillingProvider.XERO: {
      return () =>
        (window.location =
          'https://help.chaserhq.com/what-does-the-xero-app-store-subscriptions-retirement-mean-for-my-chaser-subscription');
    }
    default:
      return Chargebee({ subscriptionId: _id, shortCode: ShortCode });
  }
}

export default useManageSubscription;
